import { DataSource, Layout, Map } from "@mcleod/components";

export abstract class AutogenLayoutPartialShipmentPlanningAvailableOrdersMap extends Layout {
    mapAvailOrders: Map;
    sourcePartialShipmentPlanningAvailOrdersMap: DataSource;
}
